import { render, staticRenderFns } from "./FootballParamsEntry.vue?vue&type=template&id=16c7a5dc"
import script from "./FootballParamsEntry.vue?vue&type=script&lang=js"
export * from "./FootballParamsEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports